export * from './movimentacoes.component';